import type { JSX } from 'react';
import { Radio } from '@ksyos/design-system';
import type { RokenStatus } from '@common/customControls/bariatrics';
import type { BariPostNurseSpecialistFollowUpDataV1 } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistFollowUp/v1/bariPostNurseSpecialistFollowUpDataV1';
import type { BariPreSecretarialAssistantMedScreeningReportDataV1 } from '@common/validation/customControls/bariPre/bariPreSecretarialAssistantMedScreeningReport/v1/bariPreSecretarialAssistantMedScreeningReportDataV1';
import { rokenStatus } from '@common/customControls/bariatrics';
import {
    NumberInputColumnRowFormGroup,
    RadioGroupFormGroup,
    TextAreaFormGroup,
    TextInputFormGroup,
} from '@frontend/components/pages/episodeCategory/customControls/processActivityFormGroupFields';

export function BariatricsRokenEdit(
    props: Readonly<{
        data: BariPreSecretarialAssistantMedScreeningReportDataV1 | BariPostNurseSpecialistFollowUpDataV1;
        onChange: (
            data: Partial<BariPreSecretarialAssistantMedScreeningReportDataV1 | BariPostNurseSpecialistFollowUpDataV1>,
            validateKeys?: string | string[]
        ) => void;
    }>
): JSX.Element {
    const { data, onChange } = props;

    return (
        <>
            <RadioGroupFormGroup
                fieldKey="roken"
                isClearable={true}
                label="Roken"
                onChange={handleChangeRoken}
                radioGroupLayout="row"
            >
                {rokenStatus.map((value) => (
                    <Radio
                        key={value}
                        label={value}
                        value={value}
                    />
                ))}
            </RadioGroupFormGroup>

            {data.roken === 'Gestopt sinds...' && (
                <TextInputFormGroup
                    fieldKey="roken_gestopt_sinds"
                    label="Gestopt sinds"
                />
            )}
            {(data.roken === 'Ja' || data.roken === 'Gestopt sinds...') && (
                <>
                    <NumberInputColumnRowFormGroup
                        fieldKey="roken_aantal_pack_years"
                        label="Aantal pack years"
                        maximumFractionDigits={2}
                        tooltipText="Je rekent het aantal pakjes dat iemand per dag rookt keer het aantal jaar dat iemand rookt. Als iemand 3 jaar lang een half pakje per dag gerookt heeft is dat 1,5 pack year."
                    />
                    <TextAreaFormGroup
                        fieldKey="roken_toelichting"
                        label="Toelichting roken"
                    />
                </>
            )}
        </>
    );

    async function handleChangeRoken(value: string | null): Promise<void> {
        let changedData = {};
        if (!value || value === 'Nee') {
            changedData = {
                roken_aantal_pack_years: null,
                roken_gestopt_sinds: null,
                roken_toelichting: null,
            };
        } else if (value === 'Ja') {
            changedData = {
                roken_gestopt_sinds: null,
            };
        }

        onChange(
            {
                ...changedData,
                roken: value as RokenStatus | null,
            },
            'roken'
        );
    }
}
